import { Box, Typography, Stack, Grid } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import api from "../services/Axios";
import { useEffect, useState } from "react";

const CHART_STYLE = {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    border: "1px solid #EEF0F5",
    boxShadow: "0 2px 8px rgba(17,19,26,0.04)",
};

export default function ActiveUsersByOS({ dateRange, onLoadingChange }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getData = async () => {
        const requestId = `active-users-os-${Date.now()}-${Math.random()}`;
        setLoading(true);
        onLoadingChange(requestId, true);
        try {
            const res = await api.get("/admin/analytics/ga/operating-systems", {
                params: dateRange,
            });
            setData(res?.data?.rows || []);
        } finally {
            setLoading(false);
            onLoadingChange(requestId, false);
        }
    };

    useEffect(() => {
        getData();
    }, [dateRange, onLoadingChange]);

    const maxValue = Math.max(...data.map((r) => r.active_users), 1);

    return (
        <Grid item xs={12} md={6}>
            <Box borderRadius={2} p={2.5} sx={CHART_STYLE} height="100%">
                <Typography variant="subtitle1" fontWeight={600} mb={0.5}>
                    Active users <Box component="span" fontWeight={400}>by</Box>
                </Typography>
                <Typography variant="subtitle1" fontWeight={600} mb={2} sx={{ textDecoration: "underline", textUnderlineOffset: 4 }}>
                    Operating system
                </Typography>

                {!loading && (
                    <>
                        <Stack direction="row" justifyContent="space-between" mb={1}>
                            <Typography variant="caption" color="text.secondary" letterSpacing={0.5}>
                                OPERATING SYSTEM
                            </Typography>
                            <Typography variant="caption" color="text.secondary" letterSpacing={0.5}>
                                ACTIVE USERS
                            </Typography>
                        </Stack>

                        <Stack divider={<Box sx={{ borderBottom: "1px solid #F0F0F0" }} />}>
                            {data.map((row) => (
                                <Box key={row.os} py={1.2}>
                                    <Stack direction="row" justifyContent="space-between" mb={0.6}>
                                        <Typography variant="body2" fontWeight={500}>
                                            {row.os}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {row.active_users}
                                        </Typography>
                                    </Stack>
                                    <Box
                                        sx={{
                                            height: 2,
                                            borderRadius: 1,
                                            width: `${(row.active_users / maxValue) * 100}%`,
                                            backgroundColor: "#2979FF",
                                        }}
                                    />
                                </Box>
                            ))}
                        </Stack>
                    </>
                )}
            </Box>
        </Grid>
    );
}